<template>
  <el-dialog
      :model-value="props.visible"
      title=""
      :show-close="false"
      :width="initialWidth + 30"
      top="6vh"
      :modal="false"
      :modal-class="isMin ? 'video-dialog-txy-765 min-size' : 'video-dialog-txy-765'"
      :draggable="!isMin"
      destroy-on-close
      :close-on-click-modal="false"
      @open="onOpen"
      @closed="closedModal"
  >

    <template #header="">
      <div class="header">
        <h4>视频讲解</h4>
        <div class="right-opera">

          <el-icon
              v-if="!isMin"
              title="最小化"
              style="opacity: 0.6;position: relative;top: 4px;"
              @click="exeMinDialog">
            <SemiSelect/>
          </el-icon>

          <el-icon
              v-if="isMin"
              title="还原"
              style="opacity: 0.9;position: relative;top: 3px;"
              @click="exeRestoreDialog">
            <TopRight/>
          </el-icon>

          <el-popover
              v-if="!isMin"
              placement="top-start"
              title="缩放弹窗"
              :width="200"
              trigger="hover"
              content="this is content, this is content, this is content"
          >
            <template #reference>
              <el-icon
                  title="扩大"
                  style="transform: rotate(270deg)"
              >
                <DArrowRight/>
              </el-icon>
            </template>
            <el-slider v-model="scaleSize" :step="5" :min="5" />
          </el-popover>

          <el-icon
              class="my-close"
              @click="emit('update:visible', false)">
            <Close/>
          </el-icon>
        </div>
      </div>
    </template>

    <div
        :style="{width: initialWidth + 'px',height: (initialWidth / 16 * 9) + 'px'}"
    >
      <video id="tx-player"
             style="width: 100%;height: 100%;"
             preload="auto" playsinline webkit-playsinline
             @keydown="handleKeyDown"
      >
      </video>
    </div>

  </el-dialog>
</template>

<script setup>
import {findTxPlayerInfo} from "@/api/examCenter/exam";
import TCPlayer from 'tcplayer.js';
import {ElMessage} from "element-plus";
import {calcMinDialogLeft} from "@/components/TxPlayer/minDialogCompute.js";
import {$emit, $off, $on} from "vue-happy-bus";
import { createPlugins, tcplayerTip } from '@/utils/tcplayerOptions';

const props = defineProps({
  visible: {
    type: Boolean,
    required: true
  },
  videoId: {
    type: String,
    default: ''
  },
})

let isTPlay = false // 是否正在播放
let tPlayer = null
const initialWidth = ref(800)

function onOpen() {
  $on('dialogChange', id => {
    if (isMin.value && id != selfId) {
      calcMinDialogLeft( 'video-dialog-txy-765', 'wps-view-dialog-xxt-v2')
    }
  })
  findTxPlayerInfo({
    videoId: props.videoId
  })
      .then(res => {
        tPlayer = TCPlayer('tx-player', {
          fileID: props.videoId,
          appID: res.data.subAppId,
          psign: res.data.token,
          licenseUrl: 'https://license.vod2.myqcloud.com/license/v2/1321573871_1/v_cube.license',
          language: 'en',
          autoplay: true,
          width: '100%',
          height: '100%',
          playbackRates: [0.8, 1, 1.2, 1.5,1.8, 2],
          languages: {
            "en": {
              "360P": "流畅",
              "高清": "高清",
              "auto": "标清"
            }
          },
          plugins: createPlugins()
        });

        tPlayer.on('loadstart', () => {
        })

        tPlayer.on('loadedmetadata', () => {
          tcplayerTip.init(tPlayer)
        })

        // 腾讯视频播放完毕
        tPlayer.on('ended', () => {
          isTPlay = false
        })

        // 腾讯视频暂停
        tPlayer.on('pause', () => {
          isTPlay = false
        })

        // 腾讯播放视频
        tPlayer.on('playing', () => {
          isTPlay = true
          tcplayerTip.clear(tPlayer)
        })
      })
}

function handleKeyDown(ev) {
  switch (ev.which) {
    case 32: // 空格键
      if (isTPlay) {
        tPlayer.pause()
      } else {
        tPlayer.play()
      }
      break
    case 39: // 右键(快进)
      const next = tPlayer.currentTime() + 10
      const timeN = next >= tPlayer.duration() ? tPlayer.duration() : next
      tPlayer.currentTime(timeN)
      showMsg('播放进度：' + formatSeconds(timeN))
      break
    case 37: // 左键(快退)
      const prev = tPlayer.currentTime() - 10
      const timeP = prev <= 0 ? 0 : prev
      tPlayer.currentTime(timeP)
      showMsg('播放进度：' + formatSeconds(timeP))
      break
    case 38: // 上
      const upV = parseFloat((tPlayer.volume() + 0.1).toFixed(2))
      const volumeM = upV >= 1 ? 1 : upV
      tPlayer.volume(volumeM)
      showMsg('音量：' + (volumeM * 100).toFixed(0) + '%')
      break
    case 40: // 下
      const downV = parseFloat((tPlayer.volume() - 0.1).toFixed(2))
      const volumeD = downV <= 0 ? 0 : downV
      tPlayer.volume(volumeD)
      showMsg('音量：' + (volumeD * 100).toFixed(0) + '%')
      break
  }
}


/*
 * 工具方法：格式化秒为时分秒
 */
function formatSeconds(value) {
  let second = parseInt(value), minute = 0, hour = 0
  if (second >= 60) {
    minute = parseInt(second / 60)
    second = parseInt(second % 60)//  获取秒数，秒数取佘，得到整数秒数
    if (minute >= 60) {
      hour = parseInt(minute / 60)
      minute = parseInt(minute % 60)   //  获取小时后取佘的分，获取分钟除以60取佘的分
    }
  }

  const showS = parseInt(second) < 10 ? ('0' + parseInt(second)) : parseInt(second)
  let result = '0:' + showS
  if (minute > 0) {
    result = '' + parseInt(minute) + ':' + showS
  }
  if (hour > 0) {
    const showM = parseInt(minute) < 10 ? ('0' + parseInt(minute)) : parseInt(minute)
    result = '' + parseInt(hour) + ':' + showM + ':' + showS
  }
  return result
}

function showMsg(msg) {
  ElMessage.closeAll();
  ElMessage.info({
    appendTo: '#tx-player',
    message: msg,
  })
}


const emit = defineEmits(['update:visible', 'refresh'])

function closedModal() {
  emit('update:visible', false)
  isTPlay = false
  if (tPlayer != null) {
    tPlayer.pause()
    tPlayer.dispose()
    tPlayer = null
  }
  $emit('dialogChange', selfId)
  $off('dialogChange')
  isMin.value = false
}

const scaleSize = ref(50)

watch(scaleSize, n => {
  initialWidth.value = 800 + (n - 50) * 8
})

const isMin = ref(false) // 是否最小化了
const selfId = 'TxDragPlayDialog'

// 执行最小化
function exeMinDialog() {
  isMin.value = true
  calcMinDialogLeft( 'video-dialog-txy-765', 'wps-view-dialog-xxt-v2')
}

function exeRestoreDialog() {
  isMin.value = false
  $emit('dialogChange', selfId)
}
</script>

<style lang="scss">
.video-dialog-txy-765 {
  pointer-events: none;

  .el-dialog {
    pointer-events: auto;
    padding-bottom: 0;

    .header {
      display: flex;
      justify-content: space-between;
      align-content: center;

      > h4 {
        font-size: 18px;
        line-height: 24px;
      }

      .right-opera {
        cursor: pointer;

        .el-icon {
          font-size: 18px;
          margin-left: 15px;

          &:hover {
            color: var(--el-color-primary);
          }

          &:first-child {
            margin-left: 0;
          }
        }
      }
    }
  }

  &.min-size {
    .el-dialog {
      transform: initial !important;
      --el-dialog-width: 180px !important;
      margin-top: calc(100vh - 56px) !important;
      margin-left: 0 !important;
      margin-bottom: 0 !important;
      .el-dialog__header {
        //padding-bottom: 0;
        .my-close {
          position: relative;
          top: 2px;
        }
      }

      .el-dialog__body {
        visibility: hidden;
        height: 0;
        overflow: hidden;
      }
    }
  }
}
</style>
